import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";
import { CMSPath } from "../../../config/constant";
import { searchDailyProgrammeData, searchVenueAvailability } from "../../../action/resReservationV2";
import Loader from "../../UI/loader";
import ResReservationV2_2a from "./resReservationV2_2a";
import { popupOpenClose } from "../../../action/action";
import ResReservationV2_2b from "./resReservationV2_2b";
import ResReservationV2_2c from "./ResReservationV2_2c";
import { scrollToTop } from "../../../JS/scrollToTop";
import DailyProgramAckPopupV2_extended from "./dailyProgramAckPopupV2_extended";


const ResReservationV2_2 = (props) => {

    const { t } = props
    let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })
    let widgetSesstionId = localStorage.getItem("resReservationV2SessionToken");

    const [loading, setLoading] = useState(false);
    const [displayLoadingMsg, setDisplayLoadingMsg] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const [myReservationDataPresent, setMyReservationDataPresent] = useState(false);

    const [preferredVenueDetails, sePreferredVenueDetails] = useState({
        "date": "",
        "startTime": "",
        "endTime": "",
        "guestCount": "2",
        "guestComment": "",
        "shiftCategory": "",
        "reservationTime": "",
        "firstName": "",
        "lastName": "",
        "email": "",
        "phoneNumber": "",
        "dailyProgramAck" : false
    })

    const [availableTimes, setAvailableTimes] = useState([]);

    const [askDailyProgrammeAck, setAskDailyProgrammeAck] = useState(false);
    const [selectedTimeDailyProgrammeData, setSelectedTimeDailyProgrammeData] = useState([]);
    const [dailyProgrammeData, setDailyProgrammeData] = useState([])


    const handleAdditionalDetailsNext = (additionalDetails) => {
        sePreferredVenueDetails({...preferredVenueDetails, ...additionalDetails});

        props.next({...preferredVenueDetails, ...additionalDetails});
    }

    const handleAvailableTimeSelect = (selectedTimeData) => {
        sePreferredVenueDetails({...preferredVenueDetails, ...selectedTimeData})
        handleGoNext({...preferredVenueDetails, ...selectedTimeData})
    }

    const handleSelectVenueDetailsNext = (selectedVenueDetails) => {

        sePreferredVenueDetails({ ...preferredVenueDetails, ...selectedVenueDetails })
        setLoading(true); setDisplayLoadingMsg("Fetching availability...")

        let availabilityResolved = false;
        let programmeResolved = false;


        const checkLoadingState = () => {
            if (availabilityResolved && programmeResolved) {
                setLoading(false);
            }
        };


        // search available time.
        let searchAvailabilityPayload = {
            "venueId": props.selectedVenueId,
            "guestCount" : selectedVenueDetails.guestCount,
            "date" : selectedVenueDetails.date,
            "endTime" : selectedVenueDetails.endTime,
            "startTime" : selectedVenueDetails.startTime,
        }

        searchVenueAvailability(searchAvailabilityPayload)
            .then((res) => {

                if (res.status != 200) {

                    setLoading(false);
                    props.closeOrderPopUp(true, res.response.data.header.status.msg, "", true)

                    props.sendAnalytics(
                        props.guestDetail,
                        props.currentWidgets.widgetType,
                        "FETCH Venue Availability - ERROR",
                        { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.response.status, "errorMessage": JSON.stringify(res.response.data.header.status.msg) },
                        0,
                        props.guestIsLoggedIn
                    );
                } else {

                    if (res.data.payload.data.availability.length == 0) {
                        setLoading(false);
                        props.popupOpenClose(true, t('resReservationV2.no_time_slots_avail'))
                    } else {
                        setAvailableTimes(res.data.payload.data.availability);
                        handleGoNext(preferredVenueDetails);


                        availabilityResolved = true;
                        checkLoadingState();
                    }

                    props.sendAnalytics(
                        props.guestDetail,
                        props.currentWidgets.widgetType,
                        "FETCH Venue Availability - SUCCESS",
                        { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
                        0,
                        props.guestIsLoggedIn
                    );
                }
            })
            .catch((err) => {
                setLoading(false);
                props.closeOrderPopUp(true, t('resReservationV2.errors.error'), "", true)
            })


        // search daily programme.
        let dailyProgrammePayload = {
            "venueId": props.selectedVenueId,
            "date": selectedVenueDetails.date
        }

        searchDailyProgrammeData(dailyProgrammePayload)
            .then((res) => {
                programmeResolved = true;

                if (res.status != 200) {

                    props.sendAnalytics(
                        props.guestDetail,
                        props.currentWidgets.widgetType,
                        "FETCH DAILY PROGRAMME - ERROR",
                        { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.response.status, "errorMessage": JSON.stringify(res.response.data.header.status.msg) },
                        0,
                        props.guestIsLoggedIn
                    );
                } else {

                    res.data && res.data.payload && res.data.payload.data && setDailyProgrammeData(res.data.payload.data || []);

                    props.sendAnalytics(
                        props.guestDetail,
                        props.currentWidgets.widgetType,
                        "FETCH DAILY PROGRAMME - SUCCESS",
                        { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
                        0,
                        props.guestIsLoggedIn
                    );
                }

                checkLoadingState();

            })
            .catch((err) => {
                programmeResolved = true;
                checkLoadingState();
            })
    }

    const handleDailyAckAcceptProceed = () => {
        setAskDailyProgrammeAck(false);
        sePreferredVenueDetails({ ...preferredVenueDetails, dailyProgramAck: true })
        handleGoNext({ ...preferredVenueDetails, dailyProgramAck: true })
    }

    const handleGoNext = (preferredVenueDetailsObj = {}) => {

        if(currentPage == 1){
            setCurrentPage(2);
            return;
        }

        if(currentPage == 2){
            const matchingDailyProgrammes = dailyProgrammeData.filter((dailyProgramme) => 
                (dailyProgramme.shift_categories_display && preferredVenueDetailsObj.shiftCategory) && dailyProgramme.shift_categories_display.toLowerCase() == preferredVenueDetailsObj.shiftCategory.toLowerCase()
            );

            console.log(matchingDailyProgrammes)

            if(matchingDailyProgrammes.length > 0 && !preferredVenueDetailsObj.dailyProgramAck){
                setAskDailyProgrammeAck(true);
                setSelectedTimeDailyProgrammeData([...matchingDailyProgrammes]);
            } else {
                setCurrentPage(3);
            }

            return;
        }

    }

    const handleGoBack = () => {

        if (currentPage == 3) {
            setCurrentPage(2)
            return;
        }

        if (currentPage == 2) {
            setCurrentPage(1)
            return;
        }

        props.goBack()
    }

    useEffect(() => {
        if (!loading) setDisplayLoadingMsg("");
    }, [loading])

    useEffect(() => {
        if(currentPage !=2) scrollToTop();
    },[currentPage])

    useEffect(() => {
        if(props.myReservationData.length > 0){
            sePreferredVenueDetails({...preferredVenueDetails, firstName: props.myReservationData[0].first_name, lastName: props.myReservationData[0].last_name, email: props.myReservationData[0].email, phoneNumber: props.myReservationData[0].phone_number  })
            setMyReservationDataPresent(true);
        } else {
            const currentUserInfo = localStorage.getItem("Set_Current_Logged_In_Guest_Details") && JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))
            if(currentUserInfo) sePreferredVenueDetails({...preferredVenueDetails, firstName: currentUserInfo[0].guestProfile.firstName, lastName: currentUserInfo[0].guestProfile.lastName, email: currentUserInfo[0].guestProfile.email, phoneNumber: currentUserInfo[0].guestProfile.phoneNumber  })
        }
    },[props.myReservationData])

    useEffect(() => {

        if (!props.selectedVenueId) {
            props.closeOrderPopUp(true, t('resReservationV2.errors.no_data_found'), "", true)
            props.goBack();
            return;
        }

    }, [])

    return (
        <>
            {currentPage == 1 && <ResReservationV2_2a selectedVenueData={props.selectedVenueData} preferredVenueDetails={preferredVenueDetails} next={(preferredVenueDetails) => handleSelectVenueDetailsNext(preferredVenueDetails)} goBack={() => handleGoBack()} />}
            {currentPage == 2 && <ResReservationV2_2b selectedVenueData={props.selectedVenueData} preferredVenueDetails={preferredVenueDetails} availableTimes={availableTimes} dailyProgrammeData={dailyProgrammeData} next={(selectedTimeData) => handleAvailableTimeSelect(selectedTimeData)} goBack={() => handleGoBack()} />}
            {currentPage == 3 && <ResReservationV2_2c selectedVenueData={props.selectedVenueData} preferredVenueDetails={preferredVenueDetails} myReservationDataPresent={myReservationDataPresent} next={(additionalDetails) => handleAdditionalDetailsNext(additionalDetails)} goBack={() => handleGoBack()} />}
            {askDailyProgrammeAck && <DailyProgramAckPopupV2_extended selectedTimeDailyProgrammeData={selectedTimeDailyProgrammeData} proceed={handleDailyAckAcceptProceed} close={() => setAskDailyProgrammeAck(false)} />}
            {loading && <Loader displayMsg={displayLoadingMsg} />}
        </>
    )

}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps, { closeOrderPopUp, popupOpenClose, sendAnalytics })(withTranslation('translations')(ResReservationV2_2));